module.exports = __webpack_public_path__ + "static/media/JohnHancock.856cc3b9.webp";